import { Paper, Title, Text, Group, Button, Center, Image } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import logo from '../../assets/ramboll-logo.svg';
import bgImage from '../../assets/rims_bg_launch_screen.png';
import useTransientStore from '../../data/transcientStore';
import { useTranslation } from "../../hooks/useTranslation";

const backgroundImageUrl = bgImage;

export function NotRegistered() {
  const selectedAddressSystem = useTransientStore((state) => state.selectedAddressSystem);
  const addrIdFromStore = selectedAddressSystem?.id || 0;

  const { getTranslation } = useTranslation({ pageId: 311, addressSystemId: addrIdFromStore || 0, autoLoad: true });

    const username = useTransientStore((state) => state.currentUser);

    return (
        <div style={{ minHeight: '100vh', width: '100vw', backgroundImage: `url(${backgroundImageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
            <Paper shadow="xl" radius="lg" p="xl" style={{ maxWidth: 450, width: '90vw', textAlign: 'center', background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(8px)', border: '1px solid rgba(255,255,255,0.6)' }}>
                <Center mb="md">
                    <IconAlertTriangle size={48} color="#fa5252" />
                </Center>
                <Title order={3} mb="sm" style={{ color: '#005eb8', fontWeight: 700 }}>
                    {getTranslation("LABEL_NOT_REGISTERED_TITLE") || "Not Registered"}
                </Title>
                <Text size="md" c="dimmed" mb="lg">
                    {getTranslation("LABEL_NOT_REGISTERED_MESSAGE") || "Sorry,"} <b>{username}</b>! {getTranslation("LABEL_NOT_REGISTERED_SUBMESSAGE") || "You are not registered with the application."}
                </Text>
                <Text size="sm" c="dimmed" mb="lg">
                    {getTranslation("LABEL_NOT_REGISTERED_SUPPORT") || "Please contact your administrator or support team to request access."}
                </Text>
                <Button variant="filled" color="orange" radius="md" size="md" onClick={() => window.location.reload()}>
                    {getTranslation("LABEL_NOT_REGISTERED_RETRY_LOGIN") || "Retry Login"}
                </Button>
                <Group justify="center" mt="lg" gap={8} wrap="nowrap" style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Image src={logo} alt="Ramboll logo" maw={150} style={{ display: 'inline-block' }} />
                    <Text size="sm" c="dimmed" style={{ whiteSpace: 'nowrap' }}>&copy; RIMS {new Date().getFullYear()}</Text>
                </Group>
            </Paper>
        </div>
    );
}
